import { render } from "./PartnerConfiguration.vue?vue&type=template&id=8e130606&scoped=true&ts=true"
import script from "./PartnerConfiguration.vue?vue&type=script&lang=ts"
export * from "./PartnerConfiguration.vue?vue&type=script&lang=ts"

import "./PartnerConfiguration.vue?vue&type=style&index=0&id=8e130606&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e130606"]])

export default __exports__